'use strict';
// Polyfill webpack require.ensure for testing
if (typeof require.ensure !== `function`) require.ensure = (dependencies, callback) => callback(require);

export default function() {
  return new Promise(function(resolve, reject) {
    require.ensure([], function(require) {
      try {
        // New v10 approach
        const hljs = require('highlight.js/lib/core');
        // Register languages you need
        const javascript = require('highlight.js/lib/languages/javascript');
        hljs.registerLanguage('javascript', javascript);
        // Add other languages as needed
        resolve(hljs);
      } catch (e) {
        reject (e);
      }
    }, function(err) {
      reject(err);
    }, 'HighlightJS');
  });
}
